import apiWorker from '../apiWorker'

const _signing_documents = {
    findById : (signing_document_id, access_code) => apiWorker('get',  `/v1/signing/documents/${signing_document_id}/${access_code}`, null, true),
    password : (signing_document_id, data)        => apiWorker('post',  `/v1/signing/documents/${signing_document_id}/password`, data, true),
    sign : (signing_document_id, data)        => apiWorker('post',  `/v1/signing/documents/${signing_document_id}/sign`, data, true),
}

export default _signing_documents